/* MULE Services page — shared behavior (reveal-on-scroll + FAQ accordion).
   Guarded so loading it from multiple sections binds handlers only once.
   Uses delegation + a MutationObserver-free re-scan on Shopify section
   load events so it keeps working inside the theme editor. */
(function () {
  if (window.__svcsInit) return;
  window.__svcsInit = true;

  // --- Reveal on scroll ---
  var io = null;
  function getObserver() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('svcs-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    return io;
  }

  function observeReveals(root) {
    var obs = getObserver();
    var els = (root || document).querySelectorAll('.svcs-reveal:not(.svcs-in)');
    if (!obs) {
      // No IO support — just show everything
      els.forEach(function (el) { el.classList.add('svcs-in'); });
      return;
    }
    els.forEach(function (el, i) {
      el.style.transitionDelay = (i % 3) * 55 + 'ms';
      obs.observe(el);
    });
  }

  // --- FAQ accordion (event delegation) ---
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.svcs-faq-q');
    if (!q) return;
    var item = q.parentElement;
    var a = q.nextElementSibling;
    if (!item || !a) return;
    var isOpen = item.classList.contains('svcs-open');

    // Close siblings within the same list
    var list = item.parentElement;
    if (list) {
      list.querySelectorAll('.svcs-faq-item.svcs-open').forEach(function (i) {
        i.classList.remove('svcs-open');
        var body = i.querySelector('.svcs-faq-a');
        if (body) body.style.maxHeight = null;
      });
    }
    if (!isOpen) {
      item.classList.add('svcs-open');
      a.style.maxHeight = a.scrollHeight + 'px';
    }
  });

  function init(root) { observeReveals(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Re-scan when a section is (re)loaded in the theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
